
// @ts-nocheck
declare var gGDPR_logoURL: string;

declare var gGDPR_privacyPolicyURL: string;

import { Emit, Component, Prop, Vue } from "vue-facing-decorator";
import SensitiveDataList from './SensitiveDataList.vue';
import ConsentItem from './ConsentItem.vue';

import {  UsMt } from '@iabgpp/cmpapi' 
import { updateCMPMontana } from './updateCMPFuncs.js'

@Component({
  components: {
    SensitiveDataList,
    ConsentItem
  },
  props: {
    cmpApi: Object,
  },  

})

export default class LayerStateMontana extends Vue {

	privacyPageURL = "";
  forcedFixedPosition = false;
  logo_URL = typeof gGDPR_logoURL  == "string" ? gGDPR_logoURL : "";

  consentToSharing = true;
  consentToTargeting = true;
  sectionName = UsMt.NAME;
  sectionID = UsMt.ID;
  dirty = false;

  sensitiveLeadText = "Consent to the Use or Disclosure of the Consumer's Sensitive Personal Information:";
  sensitiveFeatures = [
    { position: 1, description: "Consumer’s Sensitive Data Consisting of Personal Data Revealing Racial or Ethnic Origin." },
    { position: 2, description: "Consumer’s Sensitive Data Consisting of Personal Data Revealing Religious Beliefs." },
    { position: 3, description: "Consumer’s Sensitive Data Consisting of Personal Data Revealing a Mental or Physical Health Condition or Diagnosis." },
    { position: 4, description: "Consumer’s Sensitive Data Consisting of Personal Data Revealing Sex Life or Sexual Orientation." },
    { position: 5, description: "Consumer’s Sensitive Data Consisting of Personal Data Revealing Citizenship or Immigration Status." },
    { position: 6, description: "Consumer’s Sensitive Data Consisting of Genetic Data that May Be Processed for the Purpose of Uniquely Identifying an Individual." },
    { position: 7, description: "Consumer’s Sensitive Data Consisting of Biometric Data that May Be Processed for the Purpose of Uniquely Identifying an Individual." },
    { position: 8, description: "Consumer’s Sensitive Data Consisting of Precise Geolocation Data." },
  ];

  mounted(): void {
    console.log("Montana Mounted");
    this.privacyPageURL = typeof gGDPR_privacyPolicyURL  == "string" ? gGDPR_privacyPolicyURL : "";

    if ( this.cmpApi.hasSection( this.sectionName ) ) {
      this.consentToSharing = this.cmpApi.getFieldValue(this.sectionName, 'SaleOptOut' ) == 2  ? true : false;
      this.consentToTargeting = this.cmpApi.getFieldValue(this.sectionName, 'TargetedAdvertisingOptOut') == 2  ? true : false;
    } else {
      updateCMPMontana( true, this.cmpApi, this.consentToSharing, this.consentToTargeting )
    }  
  }

  sensitiveDataChange( consentArray ) {
    console.log("LayerStateMontana: sensitiveDataChange(): event=", consentArray);
    this.dirty = true;
  }

  @Emit('changeViewEvent')
	saveSettingsClick(consentToAll : Boolean): string {
    if ( consentToAll)  {
      this.consentToSharing = true;
      this.consentToTargeting = true;
    }

		updateCMPMontana( consentToAll, this.cmpApi, this.consentToSharing, this.consentToTargeting )
    this.cmpApi.fireEvent( "sectionChanged", this.sectionName);
    return 'close'
	}
  
}
